import { environment } from "../environments/environment";


export class Constants {
    public static alert_dismiss: number = 3000;
    public static page_size: number = 10;

    public static getApiEndpoint() {
        return environment.apiUrl;
    }
}